import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Col, Row } from 'antd';
import { BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import PreClearanceCategorieForm from '@app/components/apps/PreClearanceCategories/PreClearanceCategoryForm';
import { useHeader } from '@app/components/header/layouts/HeaderContext';

export const EditPreClearanceCategoryPage: React.FC = () => {
  const location = useLocation();
  const { id } = location.state || {};
  const [currentBreadcrumName, setCurrentBreadcrumName] = useState<string>('Edit Pre-Clearance Category');
  const { setBreadcrumb, clearHeaderButtons } = useHeader();

  const routes = [
    {
      path: '/pre-clearance-categories',
      breadcrumbName: 'Pre-Clearance Categories',
    },
    {
      path: '/edit-pre-clearance-category',
      breadcrumbName: currentBreadcrumName,
    },
  ];

  useEffect(() => {
    setBreadcrumb(<BaseBreadcrumbWithRender routes={routes} separator=">" />);

    return () => {
      setBreadcrumb(currentBreadcrumName);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, clearHeaderButtons, currentBreadcrumName]);

  return (
    <>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <PreClearanceCategorieForm
            type="edit"
            setCurrentBreadcrumName={setCurrentBreadcrumName}
            pageTitle={'Edit Pre-Clearance Category'}
            editable={true}
            id={id}
          />
        </Col>
      </Row>
    </>
  );
};

export default EditPreClearanceCategoryPage;
